module.exports = __webpack_public_path__ + "number_plate.9f13be8d624f3905ac51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/number_plate.svg
// module id = 1023
// module chunks = 25